import { useState } from "react";
import apiClient from "../utils/api/apiClient";
import { toast } from "react-toastify";
import { useAuth } from "../contexts/AuthContext";

const useApi = (startLoading = true) => {
  const { user, setLoading, loading } = useAuth();
  const [data, setData] = useState();
  const [error, setError] = useState();

  const apiCall = async (params) => {
    if (!user?.access_token) {
      return null;
    }

    const {
      url,
      dataToSend = {},
      onSuccess = () => {},
      onFail = () => {},
      method,
      processData,
      responseType,
      headers,
      accessor = "",
      itemAccessor = "",
    } = params;
    try {
      setLoading(startLoading);

      let apiData = await apiClient({
        url,
        data: dataToSend,
        method: method?.toUpperCase(),
        responseType,
        headers,
      });

      if (apiData.headers["content-type"] === "application/octet-stream") {
        setData(apiData);
        await onSuccess(apiData);
      }

      if (
        apiData?.data?.data &&
        [200, 201, 202, 203, 204].includes(apiData?.data?.code)
      ) {
        let finalData = apiData.data?.data;
        if (processData && typeof processData === "function") {
          finalData = processData(apiData?.data?.data);
        }
        if (processData && typeof processData === "boolean") {
          let tempData = accessor
            ? apiData.data.data[accessor]
            : apiData.data.data;
          finalData = tempData?.map((item) => {
            let obj = {};
            const tempItem = itemAccessor ? item?.[itemAccessor] : item;
            tempItem?.dataModalAttributeSet?.forEach((data) => {
              obj[data?.metadataTechnicalName] = data?.attributeValue;
              if (data?.id) {
                obj.id = data?.id;
              }
              obj.documents = [];
              tempItem.documents?.forEach((doc) => {
                const obj2 = {};
                doc?.dataModalAttributeSet?.forEach((data) => {
                  obj2[data?.metadataTechnicalName] = data?.attributeValue;
                  if (data?.id) {
                    obj2.id = data?.id;
                  }
                });

                if (doc?.workflowStepResponses)
                  doc?.workflowStepResponses.forEach((item) => {
                    if (item.userLabel === "L1") {
                      obj2.L1 = item || {};
                    } else if (item.userLabel === "L2") {
                      obj2.L2 = item || {};
                    } else if (item.userLabel === "L3") {
                      obj2.L3 = item || {};
                    } else if (item.userLabel === "Finance") {
                      obj2.Finance = item || {};
                    }
                  });

                if (doc?.id) {
                  obj2.file_id = doc?.id;
                }

                if (doc?.documentName) {
                  obj2.filename = doc?.documentName;
                }

                obj.documents.push(obj2);
              });

              if (item?.workflowStepResponses) {
                item?.workflowStepResponses.forEach((item) => {
                  if (item.userLabel === "L1") {
                    obj.L1 = item || {};
                  } else if (item.userLabel === "L2") {
                    obj.L2 = item || {};
                  } else if (item.userLabel === "L3") {
                    obj.L3 = item || {};
                  } else if (item.userLabel === "Finance") {
                    obj.Finance = item || {};
                  }
                });
              }
            });

            if (item?.submittedOn) {
              obj.submittedOn = item?.submittedOn;
            }
            if (item?.l1) {
              obj.L1 = item?.l1;
            }
            if (item?.l2) {
              obj.L2 = item?.l2;
            }
            if (item?.l3) {
              obj.L3 = item?.l3;
            }
            if (item?.finance) {
              obj.Finance = item?.finance;
            }
            if (item?.Finance) {
              obj.Finance = item?.Finance;
            }
            if (tempItem?.id) {
              obj.vid = tempItem?.id;
            }
            obj.parentId = item.id;
            obj.status = item.status;
            // const newObj = { ...obj, subRows: [obj] };

            return obj;
          });
        }
        setData(finalData);
        await onSuccess(finalData);
      } else {
        onFail(apiData);
      }
      return apiData?.data?.data;
    } catch (err) {
      onFail(err);
      setError(err);
      if (err?.response?.data?.code === 406 && err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    apiCall,
    data,
    setData,
    error,
    setError,
    loading,
    setLoading,
  };
};

export default useApi;
